import React from 'react';
import './styles.scss';

const Maintenance = () => {
  return (
    <div styleName="wrapper" data-testid="maintenance">
      <div styleName="instruction">
        {"We're down for maintenance.\nBe right back!"}
      </div>
      <div styleName="pear-down" />
    </div>
  );
};

export default Maintenance;
